import { createAction } from 'redux-actions';
import * as actionType from './actionTypes';

const setRefreshSearch = createAction(actionType.SET_REFRESH_SEARCH);

export { setRefreshSearch };
